import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("비회원 본인인증")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_authentication_prompt_component = _resolveComponent("authentication-prompt-component")
  const _component_cellphone_authentication_component = _resolveComponent("cellphone-authentication-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, null, 512), [
      [_vShow, _ctx.showDimmed]
    ]),
    _withDirectives(_createVNode(_component_authentication_prompt_component, {
      onOpenLoginPopup: _ctx.openLoginPopup,
      onOpenCellphoneAuthenticationPopup: _ctx.openCellphoneAuthenticationPopup,
      onCloseAuthenticationPromptPopup: _ctx.closeAuthenticationPromptPopup
    }, {
      text: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onOpenLoginPopup", "onOpenCellphoneAuthenticationPopup", "onCloseAuthenticationPromptPopup"]), [
      [_vShow, _ctx.showLoginPopup]
    ]),
    _withDirectives(_createVNode(_component_cellphone_authentication_component, { onCloseCellphoneAuthenticationPopup: _ctx.closeCellphoneAuthenticationPopup }, null, 8, ["onCloseCellphoneAuthenticationPopup"]), [
      [_vShow, _ctx.showCertificationPopup]
    ])
  ], 64))
}